import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AppLayout from "./components/AppLayout";
import ComingSoon from "./components/ComingSoon";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Journey from "./pages/Journey";
import Profile from "./pages/Profile";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Circles from "./pages/Circles";
import CircleDetail from "./pages/CircleDetail";
import People from "./pages/People";
import ProfilePreview from "./pages/ProfilePreview";
import Messages from "./pages/Messages";
import SavedMessages from "./pages/SavedMessages";
import TrustSafetyDashboard from "./pages/TrustSafetyDashboard";
import Moderation from "./pages/Moderation";
import Mentors from "./pages/Mentors";
import MentorDetail from "./pages/MentorDetail";
import MentorProfileEdit from "./pages/MentorProfileEdit";
import AICompanion from "./pages/AICompanion";
import AiUsage from "./pages/AiUsage";
import Search from "./pages/Search";
import AdminFeedback from "./pages/AdminFeedback";
import { Toaster } from "./components/ui/sonner";
import { BookMarked, GraduationCap, MessageCircle, Sparkles } from "lucide-react";
import "./App.css";

function GuestRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
            <Route path="/register" element={<GuestRoute><Register /></GuestRoute>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            <Route element={<AppLayout />}>
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/journey" element={<Journey />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/circles" element={<Circles />} />
              <Route path="/circles/:cid" element={<CircleDetail />} />
              <Route path="/people" element={<People />} />
              <Route path="/people/:uid" element={<ProfilePreview />} />
              <Route path="/resources" element={<ComingSoon title="Resources" blurb="A curated library of methodology guides, IRB templates, and defense prep is coming soon." icon={BookMarked} />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/saved" element={<SavedMessages />} />
              <Route path="/search" element={<Search />} />
              <Route path="/admin/feedback" element={<AdminFeedback />} />
              <Route path="/moderation-dashboard" element={<TrustSafetyDashboard />} />
              <Route path="/mentors" element={<Mentors />} />
              <Route path="/mentors/me" element={<MentorProfileEdit />} />
              <Route path="/mentors/:mid" element={<MentorDetail />} />
              <Route path="/ai" element={<AICompanion />} />
              <Route path="/trust-center" element={<Moderation />} />
              <Route path="/admin/ai-usage" element={<AiUsage />} />
              <Route path="/ai-soon" element={<Navigate to="/ai" replace />} />
              <Route path="/messages-soon" element={<ComingSoon title="Messages" blurb="Direct messaging opens in Phase 2." icon={MessageCircle} />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
